module.exports = "<detailed-job-item ng-repeat=\"job in vm.jobs | orderBy: '-match' | limitTo: vm.pagination track by job.id\" job=\"job\"></detailed-job-item>\n<div class=\"see-more pagination\"><span ng-bind=\"vm.pagination + ' of ' + vm.jobs.length\"></span><a href=\"\" ng-click=\"vm.seeMore()\" ng-if=\"vm.pagination < vm.jobs.length\">Show more career matches</a></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/allMatchingJobs/allMatchingJobs.html
// module id = 140
// module chunks = 0 1